import React from 'react';
import { Redirect } from 'react-router-dom';
import { Provider } from '@shopify/app-bridge-react';
import { Auth } from 'aws-amplify';
import { Callback } from 'components';
import { parseQueryString } from 'lib/query-string';
import { ErrorScreen } from 'screens';
import Cookies from 'js-cookie';
import * as config from '../aws-exports';
import Bowser from 'bowser';
import classNames from 'lib/classNames';
import ReactPixel from 'react-facebook-pixel';
import { SHOPIFY_API_KEY, AUTH_TOKEN_KEY, API_GATEWAY, SHOPIFY_APP_PERMALINK, APP_DEV } from 'aws-exports';

export default class CallbackScreen extends React.Component {
	constructor(props: ICallbackScreenProps) {
		super(props);
		this.state = {
			callbackSuccess: false,
			errorMessage: null,
			sessionToken: undefined,
			shop: undefined,
			needsStorageAccess: false,
		};
	}

	// This calls our API passing all of the query string parameters plus the token we receive when we started the
	// OAuth process. If it succeeds then set callbackSuccess to true triggering a redirect. If it fails then set
	// the errorMessage in the state so we display an error
	async componentDidMount() {
		const params = parseQueryString(this.props.location.search);
		const token = localStorage.getItem(`${AUTH_TOKEN_KEY}_${params.shop}`);
		if (token === null) {
			return this.setState({ errorMessage: 'Missing token' });
		}

		const url = `${API_GATEWAY}/auth/shopify`;
		const body = {
			params,
			token,
		};
		try {
			const result = await fetch(url, {
				body: JSON.stringify(body),
				cache: 'no-cache',
				method: 'POST',
			});
			localStorage.removeItem(`${AUTH_TOKEN_KEY}_${params.shop}`);
			if (result.ok) {
				const json = await result.json();
				if (json.installEvent) {
					ReactPixel.init('991283181319598');
					ReactPixel.trackCustom('install');
				}

				const userName = params.shop.replace('.myshopify.com', '@myshopify.com');
				// await Auth.signOut();
				const user = await Auth.signIn(userName);

				if (user.challengeName === 'CUSTOM_CHALLENGE' && user.challengeParam.distraction === 'Yes') {
					await Auth.sendCustomChallengeAnswer(user, json.token);
				}
				this.setState({
					callbackSuccess: true,
					shop: params.shop,
					errorMessage: null,
				});
			} else {
				await fetch(`${API_GATEWAY}/public/logger`, {
					body: JSON.stringify(body),
					cache: 'no-cache',
					method: 'POST',
				});
				this.setState({
					callbackSuccess: false,
					errorMessage: 'API Call Failed.',
				});
			}
		} catch (err) {
			this.setState({
				callbackSuccess: false,
				errorMessage: 'API Call Failed.',
			});
		}
	}

	// This first time this is called it will render "Please wait..." while the API call is performed. If that
	// is successfull then we'll redirect to / otherwise we'll update the page to display the errorMessage
	render() {
		if (this.state.callbackSuccess) {
			const app_url = `https://${this.state.shop}/admin/apps/${SHOPIFY_APP_PERMALINK || SHOPIFY_API_KEY}`;
			window.location.href = app_url;
			return null;
		} else {
			return (
				<ErrorScreen>
					<div className={classNames('h-full flex-center flex-column')}>
						<Callback errorMessage={this.state.errorMessage} loginUrl={`/login`} />
					</div>
				</ErrorScreen>
			);
		}
	}
}

const StorageAccess = ({ app_url }) => {
	const getStorageAccess = () => {
		if (document.hasStorageAccess()) {
		}

		const hasStorageAccessPromise = document.hasStorageAccess();
		hasStorageAccessPromise.then(
			function (hasAccess) {
				if (hasAccess) {
					localStorage.setItem('STORAGE_ACCESS_GRANTED', true);
					window.location.href = app_url;
				} else {
					const requestStorageAccessPromise = document.requestStorageAccess();
					requestStorageAccessPromise.then(
						function () {
							localStorage.setItem('STORAGE_ACCESS_GRANTED', true);
							window.location.href = app_url;
						},
						function () {
							console.log('ERROR: unable to get storage access.');
						}
					);
				}
			},
			function (reason) {
				console.log(reason);
			}
		);
	};

	return (
		<div
			className={classNames('h-screen w-full flex  items-center justify-center flex-col text-gray-700')}
			style={{
				background: '#f4f6f8',
			}}
		>
			<div className={classNames('w-4/5')} style={{ maxWidth: 840 }}>
				<div className={classNames('rounder shadow overflow-hidden')}>
					<div className={classNames('py-3 px-5 bg-white text-gray-600')}>
						<h1 className={classNames('font-bold text-xl mb-2')}>Enable Cookies</h1>
						<p className={classNames('mb-1')}>
							You must manually enable cookies in this browser in order to use this app within Shopify.
						</p>
					</div>
					<div className={classNames('text-xs text-gray-600 py-2 px-5')}>
						Cookies let the app authenticate you by temporarily storing your preferences and personal
						information on your browser. They expire after 30 days.
					</div>
				</div>
				<button
					className={classNames(
						'rounded focus:outline-none focus:ring text-white bg-blue-500 py-2 px-3 mt-3 font-bold float-right'
					)}
					onClick={() => getStorageAccess()}
				>
					Enable Cookies
				</button>
			</div>
		</div>
	);
};
